import * as Type from './actionsTypes';
import { isNotificacaoLida } from '../../helpers/notificacao';

const INITIAL_STATE = {
  unreadCount: 0,
  preview: [],
  revision: 0,
};

const markPreviewRead = (preview, id, visualizadaEm) => (preview || []).map((item) => (
  item && item.id === id
    ? {
      ...item,
      lida: true,
      visualizadaEm: visualizadaEm || item.visualizadaEm || new Date().toISOString(),
    }
    : item
));

export default function notificacao(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Type.NOTIFICACAO_FETCH_COUNT_SUCCESS:
      return {
        ...state,
        unreadCount: Number.isFinite(Number(action.count)) ? Number(action.count) : 0,
      };
    case Type.NOTIFICACAO_FETCH_PREVIEW_SUCCESS:
      return {
        ...state,
        preview: action.items || [],
      };
    case Type.NOTIFICACAO_MARK_READ_SUCCESS: {
      const inPreviewUnread = (state.preview || []).some(
        (item) => item && item.id === action.id && !isNotificacaoLida(item)
      );
      const decrement = action.wasUnread || inPreviewUnread ? 1 : 0;
      return {
        ...state,
        unreadCount: Math.max(0, state.unreadCount - decrement),
        preview: markPreviewRead(state.preview, action.id, action.visualizadaEm),
        revision: state.revision + 1,
      };
    }
    case Type.NOTIFICACAO_MARK_ALL_READ_SUCCESS: {
      const now = new Date().toISOString();
      return {
        ...state,
        unreadCount: 0,
        preview: (state.preview || []).map((item) => (
          item
            ? {
              ...item,
              lida: true,
              visualizadaEm: item.visualizadaEm || now,
            }
            : item
        )),
        revision: state.revision + 1,
      };
    }
    case Type.NOTIFICACAO_LOTE_SUCCESS:
      return {
        ...state,
        revision: state.revision + 1,
      };
    case Type.NOTIFICACAO_CLEAN:
      return INITIAL_STATE;
    default:
      return state;
  }
}

export const getUnreadCount = (state) => state.rootState.notificacao.unreadCount;
export const getNotificacaoPreview = (state) => state.rootState.notificacao.preview;
export const getNotificacaoRevision = (state) => state.rootState.notificacao.revision;
